import i18n from '@/plugins/i18n'

export const PerformanceTableHeaders = {
  data: [
    { value: 'UXPCSTPL', get text() { return i18n.t('gps_variables.t_load') }, sortable: true, colorable: true },
    { value: 'UXACB68', get text() { return i18n.t('gps_variables.acc') }, sortable: true, colorable: true },
    { value: 'UXDCB13', get text() { return i18n.t('gps_variables.dec_less_-3') }, sortable: true, colorable: true },
    { value: 'UXACB58', get text() { return i18n.t('gps_variables.acc_more_2') }, sortable: true, colorable: true },
    { value: 'UXDCB14', get text() { return i18n.t('gps_variables.dec_less_-2') }, sortable: true, colorable: true },
    { value: 'CALETLDLHSR_G', get text() { return i18n.t('gps_variables.hsr_percent') }, sortable: true, width: '80px', colorable: true },
    { value: 'UXHSRmin', get text() { return i18n.t('gps_variables.hsr_min') }, sortable: true, colorable: true },
    { value: 'UXLSPmin', get text() { return i18n.t('gps_variables.sprint_min') }, sortable: true, colorable: true },
    { value: 'UXPCSEEF', get text() { return i18n.t('card_title.explosive_efforts') }, sortable: true, colorable: true },
    { value: 'UXVOL', get text() { return i18n.t('card_title.volume') }, sortable: true, colorable: true, reverse: true },
    { value: 'UXINTS', get text() { return i18n.t('gps_variables.intensity') }, sortable: true, colorable: true, reverse: true },
    { value: 'CACTCSVB1TD', get text() { return i18n.t('gps_variables.speed_0_7') }, sortable: true, colorable: true },
    { value: 'CACTCSVB2TD', get text() { return i18n.t('gps_variables.speed_7_14.4') }, sortable: true, colorable: true },
    { value: 'CACTCSVB3TD', get text() { return i18n.t('gps_variables.speed_14.4_19.8') }, sortable: true, colorable: true },
    { value: 'CALETLDMP', get text() { return i18n.t('gps_variables.anaerobic_avg_metabolic') }, sortable: true, colorable: true },
    { value: 'UXHMLD', get text() { return i18n.t('gps_variables.hml_distance') }, sortable: true, colorable: true },
    { value: 'UXMPERECAVGT', get text() { return i18n.t('gps_variables.mpe_avg_rec') }, sortable: true, colorable: false },
    { value: 'UXNUMMPE', get text() { return i18n.t('gps_variables.num_of_mpe') }, sortable: true, colorable: false },
    { value: 'UXMPETDR', get text() { return i18n.t('gps_variables.mpe_total_time') }, sortable: true, colorable: false },
    { value: 'UXMPEAVGDR', get text() { return i18n.t('gps_variables.mpe_avg_time') }, sortable: true, colorable: false },
    { value: 'UXANAENRG', get text() { return i18n.t('gps_variables.anaerobic_energy') }, sortable: true, colorable: false },
    { value: 'UXANAINDX', get text() { return i18n.t('gps_variables.anaerobic_index') }, sortable: true, colorable: false },
    { value: 'UXAERAVGMP', get text() { return i18n.t('gps_variables.anaerobic_avg_metabolic') }, sortable: true, colorable: false },
    { value: 'UXENGEXP', get text() { return i18n.t('gps_variables.energy_expenditure') }, sortable: true, colorable: false },
    { value: 'UXEQDIST', get text() { return i18n.t('gps_variables.equivalent_distance') }, sortable: true, colorable: false },
    { value: 'UXEQDISTINDX', get text() { return i18n.t('gps_variables.equivalent_distance_index') }, sortable: true, colorable: false },
    { value: 'UXAVGVEL', get text() { return i18n.t('gps_variables.avg_velocity') }, sortable: true, colorable: false },
    { value: 'UXACCALL', get text() { return i18n.t('gps_variables.total_acc') }, sortable: true, colorable: false },
    { value: 'UXDECALL', get text() { return i18n.t('gps_variables.total_dec') }, sortable: true, colorable: false },
    { value: 'UXVELALL', get text() { return i18n.t('gps_variables.total_vel') }, sortable: true, colorable: false },
    { value: 'UXVELB17', get text() { return i18n.t('gps_variables.vel_more_7.2') }, sortable: true, colorable: false },
    { value: 'UXVELB27', get text() { return i18n.t('gps_variables.vel_more_14.4') }, sortable: true, colorable: false },
    { value: 'UXVELB37', get text() { return i18n.t('gps_variables.vel_more_21.6') }, sortable: true, colorable: false },
    { value: 'UXVELB47', get text() { return i18n.t('gps_variables.vel_more_25.2') }, sortable: true, colorable: false },
    { value: 'UXVELB57', get text() { return i18n.t('gps_variables.vel_more_28.8') }, sortable: true, colorable: false },
    { value: 'UXVELB67', get text() { return i18n.t('gps_variables.vel_more_32.4') }, sortable: true, colorable: false },
    { value: 'CAPGCSMXAC', get text() { return i18n.t('gps_variables.max_acc') }, sortable: true, colorable: true },
    { value: 'CAPGCSMXDC', get text() { return i18n.t('gps_variables.min_dec') }, sortable: true, colorable: true },
    { value: 'UXMAXVELREF', get text() { return i18n.t('gps_variables.max_velocity_percent') }, sortable: true, colorable: false },
    { value: 'UXMPTOTAL', get text() { return i18n.t('gps_variables.total_metabolic_power') }, sortable: true, colorable: false },
    { value: 'CALETLDLHSR_GALL', get text() { return i18n.t('gps_variables.hsr_m') }, sortable: true, colorable: false },
    { value: 'CALETLDLSP_GALL', get text() { return i18n.t('gps_variables.spr_m') }, sortable: true, colorable: false },
    { value: 'UXPCSTD_GALL', get text() { return i18n.t('gps_variables.tdist_m') }, sortable: true, colorable: false },
    { value: 'last_name', align: 'start', get text() { return i18n.t('gps_variables.name') }, sortable: true },
    { id: 0, value: 'UXPCSTD', get text() { return i18n.t('gps_variables.t_distance') }, sortable: true, colorable: true },
    { id: 1, value: 'UXPCSTDR', get text() { return i18n.t('gps_variables.t_duration') }, sortable: true, colorable: true },
    { id: 2, value: 'minutes_played', get text() { return i18n.t('gps_variables.minutes_played') }, sortable: true, colorable: true },
    { id: 3, value: 'CALETLDLSP', get text() { return i18n.t('gps_variables.sprint') }, sortable: true, colorable: true },
    { id: 4, value: 'CALETLDLHSR', get text() { return i18n.t('gps_variables.hsr') }, sortable: true, colorable: true },
    { id: 5, value: 'UXPCSMYPM', get text() { return i18n.t('gps_variables.meters_min') }, sortable: true, colorable: true },
    { id: 6, value: 'CACGCSMXV', get text() { return i18n.t('gps_variables.max_velocity') }, sortable: true, colorable: true },
    { id: 7, value: 'CAPGCSACB13EG2', get text() { return i18n.t('gps_variables.acc_more_4') }, sortable: true, colorable: true },
    { id: 8, value: 'CAPGCSDCB13EG2', get text() { return i18n.t('gps_variables.dec_less_-4') }, sortable: true, colorable: true }
  ],
  selected: [{ value: 'last_name', align: 'start', get text() { return i18n.t('gps_variables.name') }, sortable: true },
    { id: 0, value: 'UXPCSTD', get text() { return i18n.t('gps_variables.t_distance') }, sortable: true, colorable: true },
    { id: 1, value: 'UXPCSTDR', get text() { return i18n.t('gps_variables.t_duration') }, sortable: true, colorable: true },
    { id: 2, value: 'minutes_played', get text() { return i18n.t('gps_variables.minutes_played') }, sortable: true, colorable: true },
    { id: 3, value: 'CALETLDLSP', get text() { return i18n.t('gps_variables.sprint') }, sortable: true, colorable: true },
    { id: 4, value: 'CALETLDLHSR', get text() { return i18n.t('gps_variables.hsr') }, sortable: true, colorable: true },
    { id: 5, value: 'UXPCSMYPM', get text() { return i18n.t('gps_variables.meters_min') }, sortable: true, colorable: true },
    { id: 6, value: 'CACGCSMXV', get text() { return i18n.t('gps_variables.max_velocity') }, sortable: true, colorable: true },
    { id: 7, value: 'CAPGCSACB13EG2', get text() { return i18n.t('gps_variables.acc_more_4') }, sortable: true, colorable: true },
    { id: 8, value: 'CAPGCSDCB13EG2', get text() { return i18n.t('gps_variables.dec_less_-4') }, sortable: true, colorable: true }
  ]
}

export const PlayerMatchTableHeaders = {
  data: [
    { value: 'UXPCSTPL', get text() { return i18n.t('gps_variables.t_load') }, sortable: true, colorable: true },
    { value: 'UXACB68', get text() { return i18n.t('gps_variables.acc') }, sortable: true, colorable: true },
    { value: 'UXDCB13', get text() { return i18n.t('gps_variables.dec_less_-3') }, sortable: true, colorable: true },
    { value: 'UXACB58', get text() { return i18n.t('gps_variables.acc_more_2') }, sortable: true, colorable: true },
    { value: 'UXDCB14', get text() { return i18n.t('gps_variables.dec_less_-2') }, sortable: true, colorable: true },
    { value: 'CALETLDLHSR_G', get text() { return i18n.t('gps_variables.hsr_percent') }, sortable: true, width: '80px', colorable: true },
    { value: 'UXLSPmin', get text() { return i18n.t('gps_variables.sprint_min') }, sortable: true, colorable: true },
    { value: 'UXPCSEEF', get text() { return i18n.t('card_title.explosive_efforts') }, sortable: true, colorable: true },
    { value: 'CACTCSVB1TD', get text() { return i18n.t('gps_variables.speed_0_7') }, sortable: true, colorable: true },
    { value: 'CACTCSVB2TD', get text() { return i18n.t('gps_variables.speed_7_14.4') }, sortable: true, colorable: true },
    { value: 'CACTCSVB3TD', get text() { return i18n.t('gps_variables.speed_14.4_19.8') }, sortable: true, colorable: true },
    { value: 'CALETLDMP', get text() { return i18n.t('gps_variables.anaerobic_avg_metabolic') }, sortable: true, colorable: true },
    { value: 'UXHMLD', get text() { return i18n.t('gps_variables.hml_distance') }, sortable: true, colorable: true },
    { value: 'UXMPERECAVGT', get text() { return i18n.t('gps_variables.mpe_avg_rec') }, sortable: true, colorable: false },
    { value: 'UXNUMMPE', get text() { return i18n.t('gps_variables.num_of_mpe') }, sortable: true, colorable: false },
    { value: 'UXMPETDR', get text() { return i18n.t('gps_variables.mpe_total_time') }, sortable: true, colorable: false },
    { value: 'UXMPEAVGDR', get text() { return i18n.t('gps_variables.mpe_avg_time') }, sortable: true, colorable: false },
    { value: 'UXANAENRG', get text() { return i18n.t('gps_variables.anaerobic_energy') }, sortable: true, colorable: false },
    { value: 'UXANAINDX', get text() { return i18n.t('gps_variables.anaerobic_index') }, sortable: true, colorable: false },
    { value: 'UXAERAVGMP', get text() { return i18n.t('gps_variables.anaerobic_avg_metabolic') }, sortable: true, colorable: false },
    { value: 'UXENGEXP', get text() { return i18n.t('gps_variables.energy_expenditure') }, sortable: true, colorable: false },
    { value: 'UXEQDIST', get text() { return i18n.t('gps_variables.equivalent_distance') }, sortable: true, colorable: false },
    { value: 'UXEQDISTINDX', get text() { return i18n.t('gps_variables.equivalent_distance_index') }, sortable: true, colorable: false },
    { value: 'UXAVGVEL', get text() { return i18n.t('gps_variables.avg_velocity') }, sortable: true, colorable: false },
    { value: 'UXACCALL', get text() { return i18n.t('gps_variables.total_acc') }, sortable: true, colorable: false },
    { value: 'UXDECALL', get text() { return i18n.t('gps_variables.total_dec') }, sortable: true, colorable: false },
    { value: 'UXVELALL', get text() { return i18n.t('gps_variables.total_vel') }, sortable: true, colorable: false },
    { value: 'UXVELB17', get text() { return i18n.t('gps_variables.vel_more_7.2') }, sortable: true, colorable: false },
    { value: 'UXVELB27', get text() { return i18n.t('gps_variables.vel_more_14.4') }, sortable: true, colorable: false },
    { value: 'UXVELB37', get text() { return i18n.t('gps_variables.vel_more_21.6') }, sortable: true, colorable: false },
    { value: 'UXVELB47', get text() { return i18n.t('gps_variables.vel_more_25.2') }, sortable: true, colorable: false },
    { value: 'UXVELB57', get text() { return i18n.t('gps_variables.vel_more_28.8') }, sortable: true, colorable: false },
    { value: 'UXVELB67', get text() { return i18n.t('gps_variables.vel_more_32.4') }, sortable: true, colorable: false },
    { value: 'CAPGCSMXAC', get text() { return i18n.t('gps_variables.max_acc') }, sortable: true, colorable: true },
    { value: 'CAPGCSMXDC', get text() { return i18n.t('gps_variables.min_dec') }, sortable: true, colorable: true },
    { value: 'CALETLDLSP', get text() { return i18n.t('gps_variables.sprint') }, sortable: true, colorable: true },
    { value: 'UXPCSTDR', get text() { return i18n.t('gps_variables.t_duration') }, sortable: true, colorable: true },
    { value: 'UXMAXVELREF', get text() { return i18n.t('gps_variables.max_velocity_percent') }, sortable: true, colorable: false },
    { value: 'UXMPTOTAL', get text() { return i18n.t('gps_variables.total_metabolic_power') }, sortable: true, colorable: false },
    { value: 'CALETLDLHSR_GALL', get text() { return i18n.t('gps_variables.hsr_m') }, sortable: true, colorable: false },
    { value: 'CALETLDLSP_GALL', get text() { return i18n.t('gps_variables.spr_m') }, sortable: true, colorable: false },
    { value: 'UXPCSTD_GALL', get text() { return i18n.t('gps_variables.tdist_m') }, sortable: true, colorable: false },
    { value: 'end_at', align: 'start', get text() { return i18n.t('picker.date.title') }, sortable: true, width: '150px' },
    { value: 'title', get text() { return i18n.t('performance.advanced.match') }, sortable: false, width: '250px' },
    { value: 'TL', get text() { return i18n.t('gps_variables.t_load') }, sortable: false },
    { value: 'PAIN', get text() { return i18n.t('table_headers.main_load.pain') }, sortable: false },
    { value: 'UXINTS', get text() { return i18n.t('gps_variables.intensity') }, sortable: true, colorable: true, reverse: true },
    { value: 'UXPCSTD', get text() { return i18n.t('gps_variables.t_distance') }, sortable: true, colorable: true },
    { value: 'UXPCSMYPM', get text() { return i18n.t('gps_variables.meters_min') }, sortable: true, colorable: true },
    { value: 'CAPGCSACB13EG2', get text() { return i18n.t('gps_variables.acc_more_4') }, sortable: true, colorable: true },
    { value: 'CAPGCSDCB13EG2', get text() { return i18n.t('gps_variables.dec_less_-4') }, sortable: true, colorable: true },
    { value: 'CACGCSMXV', get text() { return i18n.t('gps_variables.max_velocity') }, sortable: true, colorable: true },
    { value: 'CALETLDLHSR', get text() { return i18n.t('gps_variables.hsr') }, sortable: true, colorable: true },
    { value: 'UXHSRmin', get text() { return i18n.t('gps_variables.hsr_min') }, sortable: true, colorable: true }
  ],
  selected: [{ value: 'end_at', align: 'start', get text() { return i18n.t('picker.date.title') }, sortable: true, width: '150px' },
    { value: 'title', get text() { return i18n.t('performance.advanced.match') }, sortable: false, width: '250px' },
    { value: 'TL', get text() { return i18n.t('gps_variables.t_load') }, sortable: false },
    { value: 'PAIN', get text() { return i18n.t('table_headers.main_load.pain') }, sortable: false },
    { value: 'UXINTS', get text() { return i18n.t('gps_variables.intensity') }, sortable: true, colorable: true, reverse: true },
    { value: 'UXPCSTD', get text() { return i18n.t('gps_variables.t_distance') }, sortable: true, colorable: true },
    { value: 'UXPCSMYPM', get text() { return i18n.t('gps_variables.meters_min') }, sortable: true, colorable: true },
    { value: 'CAPGCSACB13EG2', get text() { return i18n.t('gps_variables.acc_more_4') }, sortable: true, colorable: true },
    { value: 'CAPGCSDCB13EG2', get text() { return i18n.t('gps_variables.dec_less_-4') }, sortable: true, colorable: true },
    { value: 'CACGCSMXV', get text() { return i18n.t('gps_variables.max_velocity') }, sortable: true, colorable: true },
    { value: 'CALETLDLHSR', get text() { return i18n.t('gps_variables.hsr') }, sortable: true, colorable: true },
    { value: 'UXHSRmin', get text() { return i18n.t('gps_variables.hsr_min') }, sortable: true, colorable: true }]
}

type UnitSystem = 'metric' | 'imperial'

const maxValuesPerformanceTraining = {
  metric: {
    UXPCSTD: 15000,
    UXPCSTDR: 150,
    CALETLDLSP: 500,
    CALETLDLHSR: 2500,
    UXPCSMYPM: 300,
    CACGCSMXV: 36,
    CAPGCSACB13EG2: 40,
    CAPGCSDCB13EG2: 40,
    UXPCSTPL: 1500,
    UXACB68: 250,
    UXDCB13: 250,
    UXACB58: 250,
    UXDCB14: 250,
    CALETLDLHSR_G: 30,
    UXHSRmin: 20,
    UXLSPmin: 10,
    UXPCSEEF: 200,
    UXVOL: 100,
    UXINTS: 100,
    CACTCSVB1TD: 10000,
    CACTCSVB2TD: 5000,
    CACTCSVB3TD: 3000,
    CALETLDMP: 300000,
    UXHMLD: 1000,
    CAPGCSMXAC: 10,
    CAPGCSMXDC: -10,
    UXACCALL: 150,
    UXDECALL: 150,
    HRMAX: 220,
    HRAVG: 180,
    TRIMP: 500,
    TRIMPMIN: 5
  },
  imperial: {
    UXPCSTD: 50000,
    UXPCSTDR: 150,
    CALETLDLSP: 1600,
    CALETLDLHSR: 8200,
    UXPCSMYPM: 1000,
    CACGCSMXV: 22,
    CAPGCSACB13EG2: 40,
    CAPGCSDCB13EG2: 40,
    UXPCSTPL: 1500,
    UXACB68: 250,
    UXDCB13: 250,
    UXACB58: 250,
    UXDCB14: 250,
    CALETLDLHSR_G: 30,
    UXHSRmin: 60,
    UXLSPmin: 30,
    UXPCSEEF: 200,
    UXVOL: 100,
    UXINTS: 100,
    CACTCSVB1TD: 32000,
    CACTCSVB2TD: 16400,
    CACTCSVB3TD: 9800,
    CALETLDMP: 300000,
    UXHMLD: 3200,
    CAPGCSMXAC: 33,
    CAPGCSMXDC: -33,
    UXACCALL: 150,
    UXDECALL: 150,
    HRMAX: 220,
    HRAVG: 180,
    TRIMP: 500,
    TRIMPMIN: 5
  }
}

export function getMaxValuesPerformanceTraining(unitSystem: UnitSystem) {
  return maxValuesPerformanceTraining[unitSystem] ?? maxValuesPerformanceTraining.metric
}

const maxValuesPerformanceMatch = {
  metric: {
    UXPCSTD: 15000,
    UXPCSTDR: 150,
    CALETLDLSP: 500,
    CALETLDLHSR: 2500,
    UXPCSMYPM: 300,
    CACGCSMXV: 36,
    CAPGCSACB13EG2: 20,
    CAPGCSDCB13EG2: 20,
    UXPCSTPL: 1500,
    UXACB68: 150,
    UXDCB13: 150,
    UXACB58: 150,
    UXDCB14: 150,
    CALETLDLHSR_G: 30,
    UXHSRmin: 20,
    UXLSPmin: 10,
    UXPCSEEF: 150,
    UXVOL: 100,
    UXINTS: 100,
    CACTCSVB1TD: 8000,
    CACTCSVB2TD: 6000,
    CACTCSVB3TD: 2000,
    CALETLDMP: 300000,
    UXHMLD: 1000,
    CAPGCSMXAC: 10,
    CAPGCSMXDC: -10,
    HRMAX: 220,
    HRAVG: 180,
    TRIMP: 500,
    TRIMPMIN: 5
  },
  imperial: {
    UXPCSTD: 49000,
    UXPCSTDR: 150,
    CALETLDLSP: 1600,
    CALETLDLHSR: 8200,
    UXPCSMYPM: 1000,
    CACGCSMXV: 22,
    CAPGCSACB13EG2: 20,
    CAPGCSDCB13EG2: 20,
    UXPCSTPL: 1500,
    UXACB68: 150,
    UXDCB13: 150,
    UXACB58: 150,
    UXDCB14: 150,
    CALETLDLHSR_G: 30,
    UXHSRmin: 65,
    UXLSPmin: 32,
    UXPCSEEF: 150,
    UXVOL: 100,
    UXINTS: 100,
    CACTCSVB1TD: 28000,
    CACTCSVB2TD: 19000,
    CACTCSVB3TD: 7000,
    CALETLDMP: 300000,
    UXHMLD: 3200,
    CAPGCSMXAC: 32,
    CAPGCSMXDC: -32,
    HRMAX: 220,
    HRAVG: 180,
    TRIMP: 500,
    TRIMPMIN: 5
  }
}

export function getMaxValuesPerformanceMatch(unitSystem: UnitSystem) {
  return maxValuesPerformanceMatch[unitSystem] ?? maxValuesPerformanceMatch.metric
}

const maxValuesPerformanceWeekly = {
  metric: {
    UXPCSTD_AL: 60000,
    UXPCSTDR_AL: 1000,
    CALETLDLSP_AL: 1000,
    CALETLDLHSR_AL: 3000,
    UXPCSMYPM_AL: 300,
    CACGCSMXV_AL: 36,
    CAPGCSACB13EG2_AL: 20,
    CAPGCSDCB13EG2_AL: 20,
    UXPCSTPL_AL: 6000,
    UXACB68_AL: 150,
    UXDCB13_AL: 150,
    UXDCB13: 150,
    UXACB58_AL: 150,
    UXDCB14_AL: 150,
    UXHSRmin_AL: 100,
    UXLSPmin_AL: 100,
    UXPCSEEF_AL: 200,
    UXVOL_AL: 100,
    UXINTS_AL: 100,
    CACTCSVB1TD_AL: 50000,
    CACTCSVB2TD_AL: 20000,
    CACTCSVB3TD_AL: 6000,
    CALETLDMP_AL: 300000,
    UXHMLD_AL: 1000,
    CAPGCSMXAC_AL: 10,
    CAPGCSMXDC_AL: -10
  },
  imperial: {
    UXPCSTD_AL: 200000,
    UXPCSTDR_AL: 1000,
    CALETLDLSP_AL: 3200,
    CALETLDLHSR_AL: 9800,
    UXPCSMYPM_AL: 1000,
    CACGCSMXV_AL: 22,
    CAPGCSACB13EG2_AL: 20,
    CAPGCSDCB13EG2_AL: 20,
    UXPCSTPL_AL: 6000,
    UXACB68_AL: 150,
    UXDCB13_AL: 150,
    UXDCB13: 150,
    UXACB58_AL: 150,
    UXDCB14_AL: 150,
    UXHSRmin_AL: 330,
    UXLSPmin_AL: 330,
    UXPCSEEF_AL: 200,
    UXVOL_AL: 100,
    UXINTS_AL: 100,
    CACTCSVB1TD_AL: 160000,
    CACTCSVB2TD_AL: 65000,
    CACTCSVB3TD_AL: 20000,
    CALETLDMP_AL: 300000,
    UXHMLD_AL: 3300,
    CAPGCSMXAC_AL: 32,
    CAPGCSMXDC_AL: -32
  }
}

export function getMaxValuesPerformanceWeekly(unitSystem: UnitSystem) {
  return maxValuesPerformanceWeekly[unitSystem] ?? maxValuesPerformanceWeekly.metric
}

const maxValuesPerformanceIndividual = {
  metric: {
    UXPCSTDR_DL: 150,
    UXPCSTDR_WL: 1000,
    UXPCSTD_DL: 15000,
    UXPCSTD_WL: 60000,
    UXVOL_DL: 100,
    UXVOL_WL: 100,
    UXVOL_G_60_ALL: 100,
    UXINTS_DL: 100,
    UXINTS_WL: 100,
    UXINTS_G_60_ALL: 100,
    CAPGCSMXAC_DL: 8,
    CAPGCSMXAC_WL: 8,
    CAPGCSMXAC_G_60_ALL: 8,
    CACGCSMXV_DL: 36,
    CACGCSMXV_WL: 36,
    CACGCSMXV_G_60_ALL: 36,
    CALETLDLHSR_DL: 2500,
    CALETLDLHSR_WL: 3000,
    UXHSRmin_DL: 70,
    UXHSRmin_WL: 490,
    CALETLDLSP_DL: 250,
    CALETLDLSP_WL: 1000,
    UXLSPmin_DL: 35,
    UXLSPmin_WL: 245,
    CACTCSVB1TD_DL: 10000,
    CACTCSVB1TD_WL: 50000,
    CACTCSVB2TD_DL: 5000,
    CACTCSVB2TD_WL: 20000,
    CACTCSVB3TD_DL: 3000,
    CACTCSVB3TD_WL: 6000
  },
  imperial: {
    UXPCSTDR_DL: 150,
    UXPCSTDR_WL: 1000,
    UXPCSTD_DL: 49000,
    UXPCSTD_WL: 200000,
    UXVOL_DL: 100,
    UXVOL_WL: 100,
    UXVOL_G_60_ALL: 100,
    UXINTS_DL: 100,
    UXINTS_WL: 100,
    UXINTS_G_60_ALL: 100,
    CAPGCSMXAC_DL: 8,
    CAPGCSMXAC_WL: 8,
    CAPGCSMXAC_G_60_ALL: 8,
    CACGCSMXV_DL: 36,
    CACGCSMXV_WL: 36,
    CACGCSMXV_G_60_ALL: 36,
    CALETLDLHSR_DL: 8500,
    CALETLDLHSR_WL: 10000,
    UXHSRmin_DL: 250,
    UXHSRmin_WL: 1500,
    CALETLDLSP_DL: 250,
    CALETLDLSP_WL: 1000,
    UXLSPmin_DL: 120,
    UXLSPmin_WL: 850,
    CACTCSVB1TD_DL: 33000,
    CACTCSVB1TD_WL: 180000,
    CACTCSVB2TD_DL: 16500,
    CACTCSVB2TD_WL: 66000,
    CACTCSVB3TD_DL: 10000,
    CACTCSVB3TD_WL: 20000
  }
}

export function getMaxValuesPerformanceIndividual(unitSystem: UnitSystem) {
  return maxValuesPerformanceIndividual[unitSystem] ?? maxValuesPerformanceIndividual.metric
}

export const reversedVariables = [
  'UXINTS',
  'UXVOL',
  'HRMAX',
  'HRAVG',
  'TG'
]
